/**
 * Valid benefit field names for EAP LOC
 *
 * Used to filter out fields that don't belong to EAP benefits when saving to API.
 * These fields represent the API structure (all flat fields for EAP).
 */

export const EAP_VALID_FIELDS = new Set([
  "objectType",
  "participationRequirements",
  "faceToFaceVisits",
  "perOccurrencePerYear",
  "unlimitedTelephonic",
  "legalFinancialResources",
  "tiedToAnotherLoc",
  "employerContribution",
  "benefitClassAvailability",
  "extended",
]);
